import PropTypes from 'prop-types';
import styles from './Checkbox.module.scss';

export default function Checkbox(props) {
	const { id, checked, onClick, content, link, onLink, last } = props;
	return (
		<div className={`${last && styles['container--last']} ${styles.container}`}
		>
			<input className={styles.container__checkbox} id={id} type='checkbox' checked={checked || false} onChange={onClick} />
			<span className={styles.container__content}>{content}</span>
			{link && (
				<span className={styles.container__link} onClick={onLink}>
					{link}
				</span>
			)}
		</div>
	);
}

Checkbox.propTypes = {
	id: PropTypes.string,
	checked: PropTypes.bool,
	onClick: PropTypes.any,
	content: PropTypes.string,
	link: PropTypes.string,
	onLink: PropTypes.any
};

Checkbox.defaultProps = {
	id: '',
	checked: false,
	onClick: '',
	content: '',
	link: '',
	onLink: ''
};
